const MAX_ATTEMPTS = 6;

export const focusWhenRendered = (findElement: () => HTMLElement | null): (() => void) => {
    let animationFrameId: number | null = null;
    let attempts = 0;
    let cancelled = false;

    const tryFocus = (): void => {
        if (cancelled) {
            return;
        }

        const element = findElement();

        if (element !== null) {
            element.focus();

            return;
        }

        attempts += 1;

        if (attempts < MAX_ATTEMPTS) {
            animationFrameId = requestAnimationFrame(tryFocus);
        }
    };

    animationFrameId = requestAnimationFrame(tryFocus);

    return () => {
        cancelled = true;

        if (animationFrameId !== null) {
            cancelAnimationFrame(animationFrameId);
        }
    };
};
